import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Wizard from "@/pages/Wizard";
import Output from "@/pages/Output";
import ChasingAfterImpact from "@/pages/ChasingAfterImpact";

function App() {
  return (
    <div className="app-shell">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/build" element={<Wizard />} />
          <Route path="/output" element={<Output />} />
          <Route path="/chasing-after-impact" element={<ChasingAfterImpact />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
